import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { LabelWithParam } from '@shared/model';

@Component(
  {
    selector: '[confirm]',
    templateUrl: './confirm-dialog.template.html',
    styleUrls: ['./confirm-dialog.style.scss'],
  }
)
export class ConfirmDialogDirective {
  @Input() confirmMessage?: LabelWithParam;
  @Input() titleMessage?: LabelWithParam;
  @Input() show: boolean = false;
  @Output() confirm = new EventEmitter();

  constructor(private elementRef: ElementRef) {
  }

  @HostListener('click', ['$event.target'])
  openConfirmation(target: any) {
    this.show = (this.elementRef.nativeElement.contains(target));
  }

  confirmAction() {
    this.show = false;
    this.confirm.emit();
  }

  close() {
    this.show = false;
  }
}
